import { injectIntl } from "react-intl";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from "@mui/material";
import { GOOGLE_MAPS_MODAL, YES_LABEL, NO_LABEL } from "../../../modules/language";
import { getMessageString } from "../../../utility";

export const GoogleMapsModalAlert = injectIntl(({ intl, modalOpen, handleClose, handleOk }) => (
  <>
    <Typography sx={{ opacity: 0 }} id="googleMapsDialog">
      Modale navigazione su Google Maps
    </Typography>
    <Dialog open={modalOpen} onClose={handleClose} className="googleMapsModalAlert" aria-labelledby="googleMapsDialog">
      <DialogContent>
        <DialogContentText>{getMessageString(intl, GOOGLE_MAPS_MODAL)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{getMessageString(intl, NO_LABEL)}</Button>
        <Button onClick={handleOk}>{getMessageString(intl, YES_LABEL)}</Button>
      </DialogActions>
    </Dialog>
  </>
));
